import React,{Component} from 'react';
import { scaleDown as Menu } from 'react-burger-menu';
import  BarContext from './BarContext'
import './SliderBar.css'
import Start from  '../page/Start'
import Novel from  '../page/Novel'
import  Blog from '../page/Blog';
import  WriteBlog from '../page/WriteBlog';
import  WriteNovel from '../page/WriteNovel';
import  WriteNovelContext from '../page/WriteNovelContext';
import Project from '../page/Project'
import About from '../page/About'





class SliderBar extends Component{
        constructor(prpos){
            super(prpos);

            this.state={
                menuOpen:false,
                login:false,
                route:'start'
            }
        }


        handleLogin(){
            this.setState(
                {
                 login:!this.state.login
                })
        }
        handleNovelRoute(){
            this.setState({
                route:'novel'
            })
        }
    handleBlogRoute(){
        this.setState({
            route:'blog'
        })
    }
    handleStartRoute(){
        this.setState({
            route:'start'
        })
    }


    handleProjectRoute(){
        this.setState({
            route:'project'
        })
    }
    handleAboutRoute(){
        this.setState({
            route:'about'
        })
    }

    writeNovel(){
        this.setState({
            route:'writeNovel'
        })
    }
    writeBlog(){
        this.setState({
            route:'writeBlog'
        })
    }
    writeNovelChapter(){
        this.setState({
            route:'writeNovelChapter'
        })
    }
    writeProject(){
        this.setState({
            route:'writeProject'
        })
    }




    render(){


        return(

            <div  id="outer-container" style={{position:'absolute',width:'100%',height:'100%',top:0,bottom:0,backgroundColor:'#ecf0f1'}}>
        <Menu pageWrapId={ "page-wrap" }  outerContainerId={ "outer-container" } >
            <BarContext handleLogin={this.handleLogin.bind(this)}
                        handleNovelRoute={this.handleNovelRoute.bind(this)}
                        handleBlogRoute={this.handleBlogRoute.bind(this)}
                        handleProjectRoute={this.handleProjectRoute.bind(this)}
                        handleAboutRoute={this.handleAboutRoute.bind(this)}
                        writeBlog={this.writeBlog.bind(this)}
                        writeNovel={this.writeNovel.bind(this)}
                        writeNovelChapter={this.writeNovelChapter.bind(this)}
                        writeProject={this.writeProject.bind(this)}
                        handleStartRoute={this.handleStartRoute.bind(this)}
            />
        </Menu>

                <div id="page-wrap" style={{backgroundImage:'url(\'pageBackground.jpg\')',backgroundSize:'cover',height:'100%',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top'}}>
                    {this.state.route=='start'?<Start handleBlogRoute={this.handleBlogRoute.bind(this)} />:''}
                    {this.state.route=='novel'?<Novel/>:''}
                    {this.state.route=='blog'?<Blog  />:''}
                    {this.state.route=='about'?<About  />:''}
                    {this.state.route=='project' ?<Project  />:''}
                    {this.state.route=='writeBlog'||this.state.route=='writeProject' ?<WriteBlog  handleBlogRoute={this.handleBlogRoute.bind(this)} />:''}
                    {this.state.route=='writeNovel' ?<WriteNovel  handleNovelRoute={this.handleNovelRoute.bind(this)} />:''}
                    {this.state.route=='writeNovelChapter' ?<WriteNovelContext  handleNovelRoute={this.handleNovelRoute.bind(this)} />:''}


                    </div>






    </div>



        )
    }
}
export default SliderBar;


// WEBPACK FOOTER //
// ./src/Compent/SliderBar/SliderBar.js